// npm方式接入初始化
import { CODEBUG } from 'sfump' // 安装哪个依赖，就从哪个依赖引入

const isPrd = window._global && window._global._ENV === "production";
const ENV = isPrd? "PROD": "ALPHA"
const IS_DEBUGGER = !isPrd? true: false;

const CODEBUG_OPTION = {
  // 校园招聘APPID
  // 系统key申请找杨昊涵（01376353）
  APPID: "33cc66e0-1d62-4569-aa8c-5229faffe720",
  ENV,
  // 项目版本号
  VERSION: "1.0.0",
  //
  debug: IS_DEBUGGER,
  //
  blacklistUrls: [
    "http://localhost:8013",
    'https://cxbff.sf-express.com',
    'https://cxbff.sit.sf-express.com'
  ],
  //
  extensions: {}
};

console.log('初始化 CODEBUG', CODEBUG_OPTION);

new CODEBUG(CODEBUG_OPTION) // web实例

// sourcemapUrl: http://esg-ucem-core-shenzhen-xili1.osssit.sfcloud.local:8080/v1/AUTH_ESG-UCEM-CORE/ump-sourcemap/ESG-CRS-CORE/static/js



// WEBPACK FOOTER //
// ./src/comm/js/apm.js